import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../api/services"
import { ADMIN_DISPUTES_SLICE_NAME as SLICE_NAME } from "./adminDisputes.constants"

export const getAdminDisputes = createAsyncThunk(
  `${SLICE_NAME}/get_disputes`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminDisputes(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

// Pinning reorders the list, so the row is patched locally and the caller refetches:
// the new position comes from the backend's own ordering, not from a client-side sort.
export const pinAdminDispute = createAsyncThunk(
  `${SLICE_NAME}/pin_dispute`,
  async ({ id, pin }, { dispatch, rejectWithValue }) => {
    const response = await services.pinAdminDispute(id, pin)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return { id, pinned: !!pin }
  }
)

export const getAdminDisputesExport = createAsyncThunk(
  `${SLICE_NAME}/get_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getAdminDisputesExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
